module.exports = __webpack_public_path__ + "static/media/Cover image-image.66158e55.jpg";